import React from 'react'

import { Navbar } from 'src/refactor/components/Navbar'

interface HeaderProps {
  onRequestContact(): void
  className?: string
  showNavbar?: boolean
  children?: React.ReactNode
}

export const Header: React.FC<HeaderProps> = ({
  onRequestContact,
  className,
  showNavbar = true,
  children,
}) => (
  <header className={showNavbar ? className : undefined}>
    {showNavbar && <Navbar onRequestContact={onRequestContact} />}
    {children}
  </header>
)
